module.exports = __webpack_public_path__ + "assets/img/0cc59c13cb9686265f2f687e94c40fb5.png";